/**
 * 같은 블록 연타 콤보 — 짧은 윈도우(windowMs) 이내 재타격 시 콤보 누적 + 콤보당 반음 상승.
 * 순수 (Phaser/WebAudio 비의존) — BattlefieldRunner가 Brick의 lastHitMs/comboCount와 함께 사용.
 * 같은 블록을 빠르게 연타하면 강도 음계 비프의 음정이 미묘하게 올라가 타격 리듬감을 준다.
 */

/**
 * 다음 콤보 카운트 — 직전 타격(lastHitMs)에서 windowMs 이내 재타격이면 +1, 아니면 0(콤보 끊김).
 * lastHitMs=0(첫 타격, 미초기화)은 항상 콤보 시작(0).
 */
export function nextComboCount(
  prevCount: number,
  lastHitMs: number,
  nowMs: number,
  windowMs: number,
): number {
  if (lastHitMs > 0 && nowMs - lastHitMs <= windowMs) return prevCount + 1;
  return 0;
}

/**
 * 콤보 카운트 → 재생 음정 배수. 콤보당 semitoneStep 반음씩 상승하되 maxSemitone 상한(클램프).
 * 12-TET: 1반음 = 2^(1/12). 콤보 0 → 1.0(원음), 콤보가 상한 도달 시 2^(maxSemitone/12).
 */
export function comboPitchMultiplier(
  comboCount: number,
  semitoneStep: number,
  maxSemitone: number,
): number {
  const semis = Math.min(comboCount * semitoneStep, maxSemitone);
  return Math.pow(2, semis / 12);
}
